import { withInstall } from '@tw-element/utils'

import Pagination from './src/pagination'

export const TwPagination = withInstall(Pagination)
export default TwPagination

export * from './src/pagination'
